import { render } from "./PostViewPage.vue?vue&type=template&id=0c715bef"
import script from "./PostViewPage.vue?vue&type=script&lang=js"
export * from "./PostViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__